/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportAlarmEntry } from './reportAlarmEntry';


export interface ReportAlarms { 
    current?: Array<ReportAlarmEntry>;
    previous?: Array<ReportAlarmEntry>;
}

